import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import HouseholdScreen from '@/components/HouseholdScreen';

export default function PhoneHouseholdScreen() {
  const params = useLocalSearchParams();
  const addressId = params['addressId'] as string;
  const engagementId = params['engagementId'] as string;
  const battlePlanId = params['battlePlanId'] as string;

  return (
    <HouseholdScreen
      addressId={addressId}
      engagementId={engagementId}
      battlePlanId={battlePlanId}
      wakeLockId="phone-household"
      isPhoneEngagement={true}
    />
  );
}
